<template>
    <span v-if="mostrarBtn">
        <b-button
            variant="primary"
            @click.stop="abrir()"
            v-if="!pagamento.solicitacaoParaEnvioEmAnalise"
        >
            <span>
                <i class="fa fa-check"></i> Solicitar Autorização para Envio
                Fora do Prazo
            </span>
        </b-button>
        <!-- <span v-if="pagamento.solicitacaoParaEnvioEmAnalise">
            <strong>
                Existe uma solicitação de autorização para envio fora do prazo
                em análise.</strong
            >
        </span> -->
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Registro de Pagamento - Solicitação de Autorização para Envio
                Fora do Prazo
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSolicitar()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-check"></i> Solicitar Autorização
                    </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            justificativa: ''
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.justificativa = ''
        },

        confirmarSolicitar() {
            this.$swal({
                title: `Registro de Pagamento`,
                html: `Confirma a solicitação de autorização para envio fora do prazo do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.solicitarAutorizacao()
                }
            })
        },

        solicitarAutorizacao() {
            this.$store.dispatch('addRequest')
            let solicitacaoDto = {
                pagamentoId: this.$route.params.pagamentoId,
                justificativa: this.justificativa
            }
            this.pagamentosServicos
                .solicitarAutorizcao(solicitacaoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação realizada com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.fechar()
                        } else {
                            this.$toast.error(
                                'Erro ao realizar solicitação!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.pagamento.status === pagamentoStatus.CRIADO &&
                this.pagamento.qtdComprometimentos > 0 &&
                this.pagamento.qtdAnexos > 0 &&
                this.$temAcesso('CONT-PAG-04') &&
                !this.pagamento.envioPermitido
            )
        }
    },

    validations: {
        justificativa: {
            required
        }
    }
}
</script>
